// Shared Framer Motion presets so every page uses the same motion language.
// Pure motion (opacity/transform) only — never touches color, layout size, or content.

export const EASE = [0.16, 1, 0.3, 1];

export const fadeUp = (delay = 0, distance = 36) => ({
  hidden: { opacity: 0, y: distance },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay, ease: EASE },
  },
});

export const fadeIn = (delay = 0) => ({
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.7, delay, ease: EASE },
  },
});

export const scaleIn = (delay = 0) => ({
  hidden: { opacity: 0, scale: 0.94 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.6, delay, ease: EASE },
  },
});

export const fadeLeft = (delay = 0, distance = 40) => ({
  hidden: { opacity: 0, x: -distance },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.7, delay, ease: EASE },
  },
});

export const fadeRight = (delay = 0, distance = 40) => ({
  hidden: { opacity: 0, x: distance },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.7, delay, ease: EASE },
  },
});

export const staggerContainer = (stagger = 0.12, delayChildren = 0) => ({
  hidden: {},
  visible: {
    transition: { staggerChildren: stagger, delayChildren },
  },
});

// Applied via whileHover/whileTap on cards — lift + soften shadow via transform only.
export const cardHover = {
  rest: { y: 0, scale: 1 },
  hover: {
    y: -10,
    scale: 1.015,
    transition: { duration: 0.35, ease: EASE },
  },
  tap: { scale: 0.98, transition: { duration: 0.15, ease: EASE } },
};

// Combined reveal + hover/tap variant for interactive cards: fades/slides in
// on scroll (hidden -> visible), then lifts slightly on hover/tap.
export const cardReveal = (delay = 0, distance = 36) => ({
  hidden: { opacity: 0, y: distance, scale: 1 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.7, delay, ease: EASE },
  },
  hover: {
    y: -10,
    scale: 1.02,
    transition: { duration: 0.35, ease: EASE },
  },
  tap: { scale: 0.98, transition: { duration: 0.15, ease: EASE } },
});

export const iconHover = {
  rest: { scale: 1, rotate: 0 },
  hover: { scale: 1.12, rotate: -4, transition: { duration: 0.3, ease: EASE } },
};

export const buttonTap = {
  rest: { scale: 1 },
  hover: { scale: 1.035, transition: { duration: 0.25, ease: EASE } },
  tap: { scale: 0.96, transition: { duration: 0.12 } },
};

// Standard viewport config for whileInView reveals — fires once, a little before
// the element is fully on screen so it never feels late.
export const viewportOnce = { once: true, amount: 0.2 };
